import React, { useContext } from 'react';
import TeacherContext from '../../context/teacher/teacherContext';
import EvaluationContext from '../../context/evaluation/evaluationContext';
import { Link } from "react-router-dom";

const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
}

function MatchFromTeacher() {

    const teacherContext = useContext(TeacherContext);
    const { studentsFromTeacher } = teacherContext;

    const evaluationContext = useContext(EvaluationContext);
    const { formularios, asignarFormulario/* , evaluacion, guardarEvaluacion */ } = evaluationContext;

    const realizarEvaluacion = (form, studentId, n) => {
        sessionStorage.setItem('evaluated', n);
        const data = {
            form,
            matchedId: studentId
        }
        asignarFormulario(data)
    }

    const Student = (props) => {
        const { _id, name, last_name, phone, email, /* photo, */ career, year, mention, residence, company, functions, industry, area, goals, area_reasons, extra_studies, concerns, projection, hobbies, expectatives, needs } = props.row;

        return (
            <div className="card" key={_id}>
                <div className="card-header border-bottom">
                    <h3 className="m-0">Alumno asignado: {`${capitalize(name)} ${capitalize(last_name)}`}</h3>
                </div>
                
                <div className="card-body">
                    <div className="card-text">

                        <div className="row">

                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <div className="form-group">
                                    <h4>Datos personales</h4>
                                </div>
                            </div>

                            <div className="col-md-4 col-sm-4 col-xs-12">
                                <label htmlFor="phone">Número telefónico</label>
                                <p><i>{phone}</i></p>
                            </div>

                            <div className="col-md-4 col-sm-4 col-xs-12">
                                <label htmlFor="email">E-mail</label>
                                <p><i>{email}</i></p>
                            </div>

                            <div className="col-md-4 col-sm-4 col-xs-12 text-right">
                                { formularios?.length > 0 && (
                                    <div className="btn-group" role="group" aria-label="Basic example">
                                        { formularios.map((row) => (
                                            <button type="button" className="btn btn-outline-primary" key={row._id} onClick={() => realizarEvaluacion(row, _id, capitalize(name) + ' ' + capitalize(last_name))}>
                                                <Link to='/evaluacion' >
                                                    <i className="material-icons">list</i>
                                                    <span>Evaluación {row.number}</span>
                                                </Link>
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div>
                            
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <div className="form-group">
                                    <h4>Información académica</h4>
                                </div>
                            </div>

                            <div className="col-md-6 col-sm-6 col-xs-12">
                                <label htmlFor="career">Carrera</label>
                                <p><i>{career}</i></p>
                            </div>

                            <div className="col-md-3 col-sm-3 col-xs-12">
                                <label htmlFor="year">Año en curso</label>
                                <p><i>{year}</i></p>
                            </div>

                            <div className="col-md-3 col-sm-3 col-xs-12">
                                <label htmlFor="mention">Mención</label>
                                <p><i>{mention}</i></p>
                            </div>

                            { residence && (
                                
                                <>
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <label htmlFor="company">Empresa (Práctica profesional)</label>
                                        <p><i>{company}</i></p>
                                    </div>

                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <label htmlFor="functions">Funciones desempeñadas (Práctica profesional)</label>
                                        <p><i>{functions}</i></p>
                                    </div>
                                </>
                            )}

                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <div className="form-group">
                                    <h4>Proyección a futuro</h4>
                                </div>
                            </div>

                            <div className="col-md-6 col-sm-6 col-xs-12">
                                <label htmlFor="industry">Industria de interés</label>
                                <div className="form-group">
                                    {industry?.map((x, i) => (
                                            <span className="badge bg-light text-dark" key={i+100} >▪ {x}</span>
                                        )        
                                    )}
                                </div>
                            </div>

                            <div className="col-md-6 col-sm-6 col-xs-12">
                                <label htmlFor="area">Áreas</label>
                                <div className="form-group">
                                    {area?.map((x, i) => (
                                            <span className="badge bg-light text-dark" key={i+200} >▪ {x}</span>
                                        )        
                                    )}
                                </div>
                            </div>

                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <label htmlFor="area_reasons">¿Por qué descartó las otras áreas?</label>
                                <p><i>{area_reasons}</i></p>
                            </div>

                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <label htmlFor="extra_studies">¿Realizaría algún estudio al egresar?</label>
                                <p><i>{extra_studies}</i></p>
                            </div>

                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <label htmlFor="goals">Metas profesionales</label>
                                <p><i>{goals}</i></p>
                            </div>

                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <label htmlFor="concerns">Inquietudes principales</label>
                                <p><i>{concerns}</i></p>
                            </div>

                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <label htmlFor="projection">Proyección laboral a 5 años</label>
                                <p><i>{projection}</i></p>
                            </div>

                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <div className="form-group">
                                    <h4>Otros intereses (personales o profesionales)</h4>
                                </div>
                            </div>

                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <label htmlFor="hobbies">Hobbies, pasatiempos</label>
                                <p><i>{hobbies}</i></p>
                            </div>

                            <div className="col-md-6 col-sm-12 col-xs-12">
                                <label htmlFor="expectatives">¿Qué espera del Programa?</label>
                                <p><i>{expectatives}</i></p>
                            </div>

                            <div className="col-md-6 col-sm-12 col-xs-12">
                                <label htmlFor="needs">¿Qué necesita aprender?</label>
                                <p><i>{needs}</i></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    {
                        studentsFromTeacher?.length > 0 ? (
                            <>
                            { studentsFromTeacher?.map ((row) => (
                                <>
                                    <Student row={row} key={row._id} />
                                    <br/>
                                </>
                            ))}
                            </>
                        ) : (
                            <div className="card">
                                <div className="card-header border-bottom">
                                    <h3 className="m-0">Sin Alumno(s) asignado(s)</h3>
                                </div>
                                <div className="card-body">
                                    <div className="card-text">
                                        <div className="row">

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <h4>No cuenta con alumno(s) asignado(s), por favor comuníquese con la Coordinación del Centro de Enlace</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    </div>
                </div>
            </div>
        </>
    )
}

export default MatchFromTeacher
